/**
 * Pre-compiled fr-FR messages for FieldErrors
 * Generated by @internationalized/string-compiler
 * DO NOT EDIT MANUALLY
 */

export default {
  duplicateValue: `Cette clé est déjà utilisée. Elle doit être unique.`,
  emptyValue: `Ce champ ne peut pas être vide.`,
  invalidFormat: `Veuillez entrer un format valide.`,
  invalidFractionalNumber: `Un nombre entier est requis.`,
  invalidFromServer: `Échec de la validation du serveur. Veuillez vérifier votre saisie.`,
  invalidNegativeNumber: `Nombre négatif non pris en charge.`,
  invalidValue: `La valeur fournie n'est pas valide`,
  missingRequiredField: `Ce champ est requis. Veuillez indiquer une valeur.`,
  resourceNotFound: `Impossible de trouver la ressource demandée.`,
  valueAboveMaximum: `La valeur doit être égale ou inférieure au maximum.`,
  valueBelowMinimum: `La valeur doit être supérieure ou égale au minimum.`,
  valueBlocked: `Cette valeur n'est pas autorisée.`,
  valueOutOfRange: `La valeur doit être dans la plage acceptable.`,
  valueTooLong: `Cette valeur est trop longue.`,
  valueTooShort: `Cette valeur est trop courte.`,
};
